import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import { LANGUAGES, type Language } from "@/i18n/types";

export function LanguageSwitcher() {
  const { lang, setLang, swapLanguageInPath } = useI18n();
  const navigate = useNavigate();

  function onChange(next: Language) {
    if (next === lang) return;
    setLang(next);
    navigate(swapLanguageInPath(next));
  }

  return (
    <div
      className="inline-flex items-center gap-1 rounded-full border border-ink-100 bg-white p-1"
      role="group"
      aria-label="Language switcher"
    >
      {LANGUAGES.map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => onChange(l)}
          aria-pressed={lang === l}
          className={`rounded-full px-3 py-1 text-xs font-semibold transition ${
            lang === l ? "bg-brand-700 text-white" : "text-ink-700 hover:bg-ink-100"
          }`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
